/**
 * ViewInvoiceContractorWrapper
 *
 * Purpose:
 * - Wraps contractor invoice view to ensure back navigation returns to vendor invoices with correct tab.
 */
import React from "react";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { CONTRACTORS, VENDOR_PAYMENT, VENDOR, VENDOR_INVOICES } from "../../constants/route-paths";
import ViewInvoiceWorkOrder from '../contractors/vendor-payment/view-invoice';
import { VENDOR_TAB, VENDOR_URL_PARAM } from "../../constants/vendor.contant";

function ViewInvoiceContractorWrapper(props) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const params = useParams();

  const returnTab = searchParams.get(VENDOR_URL_PARAM.RETURN_TAB) || VENDOR_TAB.CONTRACTOR_INVOICES;
  const returnSubTab = searchParams.get(VENDOR_URL_PARAM.RETURN_SUB_TAB);

  // Override the history prop to handle return navigation
  const customHistory = (path) => {
    if (path.includes('/contractors/work-order/view/')) {
      const parts = path.split('/contractors/work-order/view/');
      navigate(`/vendor/orders/work-order/view/${parts[1]}`);
    } else if (returnTab && path.includes(`/${CONTRACTORS}/${VENDOR_PAYMENT}`)) {
      // Return to vendor invoices with the correct tab and subTab
      const subTabQuery = returnSubTab ? `&${VENDOR_URL_PARAM.SUB_TAB}=${returnSubTab}` : '';
      navigate(`/${VENDOR}/${VENDOR_INVOICES}?${VENDOR_URL_PARAM.TAB}=${returnTab}${subTabQuery}`);
    } else {
      navigate(path);
    }
  };

  return (
    <ViewInvoiceWorkOrder
      {...props}
      params={params}
      history={customHistory}
    />
  );
}

export default ViewInvoiceContractorWrapper;
